var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcabados(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1947",
    "data-name": "Grupo 1947",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.5,
    height: 82.499,
    viewBox: "0 0 82.5 82.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "piso"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M41.25,41.25V0H0V41.25ZM10.917,32.042l3.132,3.132-3.6,3.658H4.126Zm0-19.417,3.165,3.165-8,8L2.918,20.625Zm17.707-1.709-3.165,3.165-8-8,3.165-3.165Zm1.709,17.707-3.165-3.165,8-8,3.165,3.165ZM25.5,33.458l-8-8,3.125-3.125,8,8Zm-.04-9.708-3.125-3.125,8-8,3.125,3.125ZM15.751,7.792l8,8-3.125,3.125-8-8Zm.04,9.708,3.125,3.125-8,8L7.792,25.5Zm0,9.668,8,8-3.165,3.165-8-8Zm-.033,9.716,1.949,1.949H13.841Zm14.575-4.841,3.092,3.092-3.638,3.7H23.543Zm4.8,4.8,1.99,1.99H33.177Zm-3.092-6.51L35.175,27.2l3.658,3.6v6.325Zm6.791-2.924-1.949-1.917,1.949-1.949ZM32.042,10.917l3.092-3.092,3.7,3.638v6.244Zm6.791-2.844-1.99-1.957,1.99-1.99Zm-8.5,1.134L27.2,6.075l3.6-3.658h6.324ZM25.492,4.366,23.543,2.417h3.867ZM10.917,9.208,7.825,6.116l3.638-3.7h6.244Zm-4.8-4.8-1.99-1.99H8.073Zm3.092,6.51L6.075,14.049l-3.658-3.6V4.126ZM2.417,13.841l1.949,1.917L2.417,17.707ZM9.208,30.333,6.116,33.425l-3.7-3.638V23.543ZM2.417,33.177l1.99,1.957-1.99,1.99Z",
    fill: "#003082"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "suelo",
    transform: "translate(41.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M40.646,10.01a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-.6-.6H11.823a.6.6,0,0,0,0,1.208h8.2V20.021H1.208v-8.2a.6.6,0,0,0-1.208,0V40.646a.6.6,0,0,0,.6.6H29.427a.6.6,0,1,0,0-1.208h-8.2V21.229H40.041V40.042h-8.2a.6.6,0,1,0,0,1.208h8.8a.6.6,0,0,0,.6-.6V11.823a.6.6,0,1,0-1.208,0v8.2H21.229V1.208H40.041v8.2A.6.6,0,0,0,40.646,10.01ZM1.208,21.229H20.021V40.042H1.208Zm0,0",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M425.682,182.076a.6.6,0,0,0,.6-.6v-1.526l2.158-2.158h1.526a.6.6,0,1,0,0-1.209h-1.776a.6.6,0,0,0-.427.177l-2.512,2.513a.6.6,0,0,0-.177.427v1.776A.6.6,0,0,0,425.682,182.076Zm0,0",
    transform: "translate(-390.831 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M272.084,182.076a.6.6,0,0,0,.6-.6V179.7a.605.605,0,0,0-.177-.427L270,176.755a.6.6,0,0,0-.427-.177H267.8a.6.6,0,1,0,0,1.209h1.526l2.158,2.158v1.526A.6.6,0,0,0,272.084,182.076Zm0,0",
    transform: "translate(-245.665 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    "data-name": "Trazado 410",
    d: "M267.8,24.188h1.776a.6.6,0,0,0,.427-.177l2.512-2.512a.6.6,0,0,0,.177-.427V19.3a.6.6,0,0,0-1.208,0v1.526l-2.158,2.158H267.8a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-245.664 -17.185)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    "data-name": "Trazado 411",
    d: "M429.971,22.98h-1.526l-2.158-2.158V19.3a.6.6,0,0,0-1.209,0v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208Zm0,0",
    transform: "translate(-390.831 -17.186)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    "data-name": "Trazado 412",
    d: "M326.284,83.923l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8a.6.6,0,0,0-.855,0l-.351.351a1.969,1.969,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.854,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8A.6.6,0,0,0,326.284,83.923Zm-1.377-6.567.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335l-.951.951a3.18,3.18,0,0,0-4.336,0l-.951-.951a3.179,3.179,0,0,0,0-4.335Zm0,0",
    transform: "translate(-297.39 -68.909)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    "data-name": "Trazado 413",
    d: "M.6,10.01a.6.6,0,0,0,.6-.6v-8.2h8.2A.6.6,0,0,0,9.406,0H.6A.6.6,0,0,0,0,.6v8.8A.6.6,0,0,0,.6,10.01Zm0,0",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M181.471,176.578H179.7a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,1,0,1.208,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.208Zm0,0",
    transform: "translate(-162.352 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M23.584,182.076a.6.6,0,0,0,.6-.6V179.7a.605.605,0,0,0-.177-.427L21.5,176.755a.6.6,0,0,0-.427-.177H19.3a.6.6,0,0,0,0,1.209h1.526l2.158,2.158v1.526A.6.6,0,0,0,23.584,182.076Zm0,0",
    transform: "translate(-17.185 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M19.3,24.188h1.776a.6.6,0,0,0,.427-.177L24.011,21.5a.6.6,0,0,0,.177-.427V19.3a.6.6,0,0,0-1.208,0v1.526L20.822,22.98H19.3a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-17.185 -17.185)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M177.182,18.691a.6.6,0,0,0-.6.6v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208h-1.526l-2.158-2.158V19.3A.6.6,0,0,0,177.182,18.691Zm0,0",
    transform: "translate(-162.352 -17.186)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M81.267,75.127l-.351.351a1.97,1.97,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.855,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8a.6.6,0,0,0,.854,0l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8A.6.6,0,0,0,81.267,75.127Zm1.377,6.567-.951.951a3.18,3.18,0,0,0-4.335,0l-.951-.951a3.179,3.179,0,0,0,0-4.335l.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951A3.179,3.179,0,0,0,82.644,81.694Zm0,0",
    transform: "translate(-68.911 -68.912)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M429.971,425.078H428.2a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,0,0,1.209,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.209Zm0,0",
    transform: "translate(-390.831 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420",
    "data-name": "Trazado 420",
    d: "M272.084,430.576a.6.6,0,0,0,.6-.6V428.2a.605.605,0,0,0-.177-.427L270,425.255a.6.6,0,0,0-.427-.177H267.8a.6.6,0,1,0,0,1.208h1.526l2.158,2.158v1.526A.6.6,0,0,0,272.084,430.576Zm0,0",
    transform: "translate(-245.665 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M267.8,272.689h1.776a.6.6,0,0,0,.427-.177L272.511,270a.6.6,0,0,0,.177-.427V267.8a.6.6,0,0,0-1.208,0v1.526l-2.158,2.158H267.8a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-245.664 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422",
    "data-name": "Trazado 422",
    d: "M425.682,267.191a.6.6,0,0,0-.6.6v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208h-1.526l-2.158-2.158V267.8A.6.6,0,0,0,425.682,267.191Zm0,0",
    transform: "translate(-390.831 -245.664)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M326.284,332.423l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8a.6.6,0,0,0-.855,0l-.351.351a1.969,1.969,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.854,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8A.6.6,0,0,0,326.284,332.423Zm-1.377-6.567.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335l-.951.951a3.18,3.18,0,0,0-4.336,0l-.951-.951a3.179,3.179,0,0,0,0-4.335Zm0,0",
    transform: "translate(-297.39 -297.388)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424",
    "data-name": "Trazado 424",
    d: "M181.471,425.078H179.7a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,0,0,1.208,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.209Zm0,0",
    transform: "translate(-162.352 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M21.5,425.255a.6.6,0,0,0-.427-.177H19.3a.6.6,0,0,0,0,1.209h1.526l2.158,2.158v1.526a.6.6,0,0,0,1.208,0v-1.776a.6.6,0,0,0-.177-.427Zm0,0",
    transform: "translate(-17.186 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M19.3,272.689h1.776a.6.6,0,0,0,.427-.177L24.011,270a.6.6,0,0,0,.177-.427V267.8a.6.6,0,1,0-1.208,0v1.526l-2.158,2.158H19.3a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-17.185 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M181.471,271.48h-1.526l-2.158-2.158V267.8a.6.6,0,0,0-1.208,0v1.776a.6.6,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208Zm0,0",
    transform: "translate(-162.352 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M84.1,330.2a.6.6,0,0,0-.177-.427l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.855l-1.8-1.8a.6.6,0,0,0-.854,0l-.351.351a1.97,1.97,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.855,0l-1.8,1.8a.6.6,0,0,0,0,.855l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.854l1.8,1.8a.6.6,0,0,0,.855,0l.351-.351a1.969,1.969,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.854,0l1.8-1.8A.6.6,0,0,0,84.1,330.2Zm-2.408.95a3.18,3.18,0,0,0-4.335,0l-.951-.951a3.179,3.179,0,0,0,0-4.335l.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335Zm0,0",
    transform: "translate(-68.911 -297.391)",
    fill: "#003082"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "suelo-2",
    "data-name": "suelo",
    transform: "translate(0 41.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407-2",
    "data-name": "Trazado 407",
    d: "M40.646,10.01a.6.6,0,0,0,.6-.6V.6a.6.6,0,0,0-.6-.6H11.823a.6.6,0,0,0,0,1.208h8.2V20.021H1.208v-8.2a.6.6,0,0,0-1.208,0V40.646a.6.6,0,0,0,.6.6H29.427a.6.6,0,1,0,0-1.208h-8.2V21.229H40.041V40.042h-8.2a.6.6,0,1,0,0,1.208h8.8a.6.6,0,0,0,.6-.6V11.823a.6.6,0,1,0-1.208,0v8.2H21.229V1.208H40.041v8.2A.6.6,0,0,0,40.646,10.01ZM1.208,21.229H20.021V40.042H1.208Zm0,0",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408-2",
    "data-name": "Trazado 408",
    d: "M425.682,182.076a.6.6,0,0,0,.6-.6v-1.526l2.158-2.158h1.526a.6.6,0,1,0,0-1.209h-1.776a.6.6,0,0,0-.427.177l-2.512,2.513a.6.6,0,0,0-.177.427v1.776A.6.6,0,0,0,425.682,182.076Zm0,0",
    transform: "translate(-390.831 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409-2",
    "data-name": "Trazado 409",
    d: "M272.084,182.076a.6.6,0,0,0,.6-.6V179.7a.605.605,0,0,0-.177-.427L270,176.755a.6.6,0,0,0-.427-.177H267.8a.6.6,0,1,0,0,1.209h1.526l2.158,2.158v1.526A.6.6,0,0,0,272.084,182.076Zm0,0",
    transform: "translate(-245.665 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410-2",
    "data-name": "Trazado 410",
    d: "M267.8,24.188h1.776a.6.6,0,0,0,.427-.177l2.512-2.512a.6.6,0,0,0,.177-.427V19.3a.6.6,0,0,0-1.208,0v1.526l-2.158,2.158H267.8a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-245.664 -17.185)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411-2",
    "data-name": "Trazado 411",
    d: "M429.971,22.98h-1.526l-2.158-2.158V19.3a.6.6,0,0,0-1.209,0v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208Zm0,0",
    transform: "translate(-390.831 -17.186)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412-2",
    "data-name": "Trazado 412",
    d: "M326.284,83.923l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8a.6.6,0,0,0-.855,0l-.351.351a1.969,1.969,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.854,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8A.6.6,0,0,0,326.284,83.923Zm-1.377-6.567.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335l-.951.951a3.18,3.18,0,0,0-4.336,0l-.951-.951a3.179,3.179,0,0,0,0-4.335Zm0,0",
    transform: "translate(-297.39 -68.909)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413-2",
    "data-name": "Trazado 413",
    d: "M.6,10.01a.6.6,0,0,0,.6-.6v-8.2h8.2A.6.6,0,0,0,9.406,0H.6A.6.6,0,0,0,0,.6v8.8A.6.6,0,0,0,.6,10.01Zm0,0",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414-2",
    "data-name": "Trazado 414",
    d: "M181.471,176.578H179.7a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,1,0,1.208,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.208Zm0,0",
    transform: "translate(-162.352 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415-2",
    "data-name": "Trazado 415",
    d: "M23.584,182.076a.6.6,0,0,0,.6-.6V179.7a.605.605,0,0,0-.177-.427L21.5,176.755a.6.6,0,0,0-.427-.177H19.3a.6.6,0,0,0,0,1.209h1.526l2.158,2.158v1.526A.6.6,0,0,0,23.584,182.076Zm0,0",
    transform: "translate(-17.185 -162.352)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416-2",
    "data-name": "Trazado 416",
    d: "M19.3,24.188h1.776a.6.6,0,0,0,.427-.177L24.011,21.5a.6.6,0,0,0,.177-.427V19.3a.6.6,0,0,0-1.208,0v1.526L20.822,22.98H19.3a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-17.185 -17.185)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417-2",
    "data-name": "Trazado 417",
    d: "M177.182,18.691a.6.6,0,0,0-.6.6v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208h-1.526l-2.158-2.158V19.3A.6.6,0,0,0,177.182,18.691Zm0,0",
    transform: "translate(-162.352 -17.186)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418-2",
    "data-name": "Trazado 418",
    d: "M81.267,75.127l-.351.351a1.97,1.97,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.855,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8a.6.6,0,0,0,.854,0l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8A.6.6,0,0,0,81.267,75.127Zm1.377,6.567-.951.951a3.18,3.18,0,0,0-4.335,0l-.951-.951a3.179,3.179,0,0,0,0-4.335l.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951A3.179,3.179,0,0,0,82.644,81.694Zm0,0",
    transform: "translate(-68.911 -68.912)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419-2",
    "data-name": "Trazado 419",
    d: "M429.971,425.078H428.2a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,0,0,1.209,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.209Zm0,0",
    transform: "translate(-390.831 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420-2",
    "data-name": "Trazado 420",
    d: "M272.084,430.576a.6.6,0,0,0,.6-.6V428.2a.605.605,0,0,0-.177-.427L270,425.255a.6.6,0,0,0-.427-.177H267.8a.6.6,0,1,0,0,1.208h1.526l2.158,2.158v1.526A.6.6,0,0,0,272.084,430.576Zm0,0",
    transform: "translate(-245.665 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421-2",
    "data-name": "Trazado 421",
    d: "M267.8,272.689h1.776a.6.6,0,0,0,.427-.177L272.511,270a.6.6,0,0,0,.177-.427V267.8a.6.6,0,0,0-1.208,0v1.526l-2.158,2.158H267.8a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-245.664 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422-2",
    "data-name": "Trazado 422",
    d: "M425.682,267.191a.6.6,0,0,0-.6.6v1.776a.605.605,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208h-1.526l-2.158-2.158V267.8A.6.6,0,0,0,425.682,267.191Zm0,0",
    transform: "translate(-390.831 -245.664)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423-2",
    "data-name": "Trazado 423",
    d: "M326.284,332.423l.351-.351a1.97,1.97,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.855,0l1.8-1.8a.6.6,0,0,0,0-.855l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.854l-1.8-1.8a.6.6,0,0,0-.855,0l-.351.351a1.969,1.969,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.854,0l-1.8,1.8a.6.6,0,0,0,0,.854l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.855l1.8,1.8A.6.6,0,0,0,326.284,332.423Zm-1.377-6.567.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335l-.951.951a3.18,3.18,0,0,0-4.336,0l-.951-.951a3.179,3.179,0,0,0,0-4.335Zm0,0",
    transform: "translate(-297.39 -297.388)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424-2",
    "data-name": "Trazado 424",
    d: "M181.471,425.078H179.7a.6.6,0,0,0-.427.177l-2.512,2.512a.6.6,0,0,0-.177.427v1.776a.6.6,0,0,0,1.208,0v-1.526l2.158-2.158h1.526a.6.6,0,0,0,0-1.209Zm0,0",
    transform: "translate(-162.352 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425-2",
    "data-name": "Trazado 425",
    d: "M21.5,425.255a.6.6,0,0,0-.427-.177H19.3a.6.6,0,0,0,0,1.209h1.526l2.158,2.158v1.526a.6.6,0,0,0,1.208,0v-1.776a.6.6,0,0,0-.177-.427Zm0,0",
    transform: "translate(-17.186 -390.831)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426-2",
    "data-name": "Trazado 426",
    d: "M19.3,272.689h1.776a.6.6,0,0,0,.427-.177L24.011,270a.6.6,0,0,0,.177-.427V267.8a.6.6,0,1,0-1.208,0v1.526l-2.158,2.158H19.3a.6.6,0,1,0,0,1.208Zm0,0",
    transform: "translate(-17.185 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427-2",
    "data-name": "Trazado 427",
    d: "M181.471,271.48h-1.526l-2.158-2.158V267.8a.6.6,0,0,0-1.208,0v1.776a.6.6,0,0,0,.177.427l2.512,2.512a.6.6,0,0,0,.427.177h1.776a.6.6,0,1,0,0-1.208Zm0,0",
    transform: "translate(-162.352 -245.665)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428-2",
    "data-name": "Trazado 428",
    d: "M84.1,330.2a.6.6,0,0,0-.177-.427l-.351-.351a1.969,1.969,0,0,1,0-2.781l.351-.351a.6.6,0,0,0,0-.855l-1.8-1.8a.6.6,0,0,0-.854,0l-.351.351a1.97,1.97,0,0,1-2.782,0l-.351-.351a.6.6,0,0,0-.855,0l-1.8,1.8a.6.6,0,0,0,0,.855l.351.351a1.969,1.969,0,0,1,0,2.781l-.351.351a.6.6,0,0,0,0,.854l1.8,1.8a.6.6,0,0,0,.855,0l.351-.351a1.969,1.969,0,0,1,2.782,0l.351.351a.6.6,0,0,0,.854,0l1.8-1.8A.6.6,0,0,0,84.1,330.2Zm-2.408.95a3.18,3.18,0,0,0-4.335,0l-.951-.951a3.179,3.179,0,0,0,0-4.335l.951-.951a3.179,3.179,0,0,0,4.335,0l.951.951a3.179,3.179,0,0,0,0,4.335Zm0,0",
    transform: "translate(-68.911 -297.391)",
    fill: "#003082"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "piso-2",
    "data-name": "piso",
    transform: "translate(41.25 41.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406-2",
    "data-name": "Trazado 406",
    d: "M41.25,41.25V0H0V41.25ZM10.917,32.042l3.132,3.132-3.6,3.658H4.126Zm0-19.417,3.165,3.165-8,8L2.918,20.625Zm17.707-1.709-3.165,3.165-8-8,3.165-3.165Zm1.709,17.707-3.165-3.165,8-8,3.165,3.165ZM25.5,33.458l-8-8,3.125-3.125,8,8Zm-.04-9.708-3.125-3.125,8-8,3.125,3.125ZM15.751,7.792l8,8-3.125,3.125-8-8Zm.04,9.708,3.125,3.125-8,8L7.792,25.5Zm0,9.668,8,8-3.165,3.165-8-8Zm-.033,9.716,1.949,1.949H13.841Zm14.575-4.841,3.092,3.092-3.638,3.7H23.543Zm4.8,4.8,1.99,1.99H33.177Zm-3.092-6.51L35.175,27.2l3.658,3.6v6.325Zm6.791-2.924-1.949-1.917,1.949-1.949ZM32.042,10.917l3.092-3.092,3.7,3.638v6.244Zm6.791-2.844-1.99-1.957,1.99-1.99Zm-8.5,1.134L27.2,6.075l3.6-3.658h6.324ZM25.492,4.366,23.543,2.417h3.867ZM10.917,9.208,7.825,6.116l3.638-3.7h6.244Zm-4.8-4.8-1.99-1.99H8.073Zm3.092,6.51L6.075,14.049l-3.658-3.6V4.126ZM2.417,13.841l1.949,1.917L2.417,17.707ZM9.208,30.333,6.116,33.425l-3.7-3.638V23.543ZM2.417,33.177l1.99,1.957-1.99,1.99Z",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcabados);
export default __webpack_public_path__ + "static/media/acabados.7a8c439161ddce9d152280cf6e915b4a.svg";
export { ForwardRef as ReactComponent };